import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
        >
          <div >
            <p className="copyright">
              © 2025-2026 斷界召喚. 保留所有權利。<br />
              <span className="footer-note">Not affiliated with Mojang AB or Microsoft.</span><br/><br/>
              <span className="footer-note">
                Email: <a href="mailto:riftcall@riftcall.net" className="email-link">riftcall@riftcall.net</a>
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
